import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioGroupButtonComponent } from './components/radio-group-button/radio-group-button.component';
import { CustomSearchInputComponent } from './components/custom-search-input/custom-search-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberInputComponent } from './components/number-input/number-input.component';
import { CustomSelectComponent } from './components/custom-select/custom-select.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { RestrictFirstSpaceDirective } from './directives/restrict-first-space.directive';
import { NumberDirective } from './directives/numbers-only.directive';
import { CustomDatepickerComponent } from './components/custom-datepicker/custom-datepicker.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PhoneNumberDirective } from './directives/phone-number.directive';
import {PercentFormatterDirective} from '../../directives';
import { DateMaskDirective } from './directives/date-mask.directive';

@NgModule({
  declarations: [
    RadioGroupButtonComponent,
    CustomSearchInputComponent,
    NumberInputComponent,
    CustomSelectComponent,
    RestrictFirstSpaceDirective,
    NumberDirective,
    CustomDatepickerComponent,
    PhoneNumberDirective,
    PercentFormatterDirective,
    DateMaskDirective
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PopoverModule.forRoot(),
    AngularSvgIconModule.forRoot(),
  ],
  exports: [
    RadioGroupButtonComponent,
    CustomSearchInputComponent,
    NumberInputComponent,
    CustomSelectComponent,
    RestrictFirstSpaceDirective,
    NumberDirective,
    CustomDatepickerComponent,
    PhoneNumberDirective,
    PercentFormatterDirective,
  ]
})
export class SharedModule { }
